import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomeService } from 'src/app/services/home.service';
import {
  book773t,
  book856,
  bookStatic,
  HoldingAvailableIssues,
  Keywords,
  Mattype,
} from '../models/walai';
import { Meta } from '@angular/platform-browser';

import { DataService } from '../services/data.service';
import { UtilityService } from '../services/utility.service';
import { SearchService } from '../services/search.service';
import { MemberService } from '../services/member.service';
import { ConfigService } from '../services/config.service';
@Component({
  selector: 'app-bibitem',
  templateUrl: './bibitem.component.html',
  styleUrls: ['./bibitem.component.css'],
})
export class BibitemComponent implements OnInit {
  public bibid: string = '';
  public title: string = '';
  public author: string = '';
  public locationID: string = '';
  public mattypeID: string = '';
  public matTypeName: string = '';
  public mattyeIcon: String = '';
  public abstract: string = '';
  public contents: any[] = [];
  public havesubject: boolean = false;
  public haveISBN: boolean = false;
  public haveAuthor: boolean = false;
  public addedAuthor: boolean = false;
  public bookcoverUrl: string = '';
  public infoList: any[] = [];
  public groupedInfoList: { field: string, values: string[] }[] = [];
  public expandedFields: Map<string, boolean> = new Map();
  public expandedValues: Map<string, boolean> = new Map(); // Track individual value expansion
  public subjectList!: any[];
  public isbnList: any[] = [];
  public authorList: any[] = [];
  public addedAuthorList: any[] = [];
  public isAddedAuthorExpanded: boolean = false;
  public bookRelated: any[] = [];
  public AllTitleInIssue: any[] = [];
  public book856: book856[] = [];
  public objBook773t: book773t = {
    label: '',
    data: '',
  };

  public bookStatic: bookStatic = {
    LASTUSE: '',
    CHECKOUTCOUNT: 0,
    OPACVIEW: 0,
    MYLIST: 0,
    DOWNLOAD: 0,
  };
  validParameter = true;
  public isBook = true;
  public isSerial = false;
  public isArticle = false;

  public HoldingAvailableIssues: HoldingAvailableIssues[] = [];

  public covers: string[] = [];
  public bookCoverPath: string = '';

  public inLoop = true;
  loading = true;
  url = '';

  currentUser: any[] = [];
  opacopenRD = false;
  NDDUserPrivilege = false;
  BLOCKUSER = false;
  IsImageError: boolean = false;
  isSubjectExpanded: boolean = false;
  isIsbnExpanded: boolean = false;

  noimage = 'assets/images/bookcover/noimage.jpg';

  constructor(
    private route: ActivatedRoute,
    private homeService: HomeService,
    private spinner: NgxSpinnerService,
    private meta: Meta,
    private data: DataService,
    private fc: UtilityService,
    private searchService: SearchService,
    private memberService: MemberService,
    private configService: ConfigService,
    private matType: Mattype
  ) {
    //this.noimage = '';
    // try {
    //   this.homeService
    //     .getFilePath('OpacImages')
    //     .subscribe(async (data: any) => {
    //       this.noimage = data + '/noimage.jpg';
    //     });
    // } catch (error) {
    // this.noimage = 'assets/images/bookcover/noimage.jpg';
    // }
  }

  imagerror(e : any) {
    //e.target.hidden = true;
    e.target.src = 'assets/images/bookcover/noimage.jpg';
    e.target.onerror = null;
  }

  public async ngOnInit(): Promise<void> {
    this.url = window.location.href;

    // bibid ที่ถูกส่งมาแบบ  Get ผ่าน Url
    try {
      this.bibid = this.route.snapshot.queryParamMap.get('bibid') ?? '';
    } catch (error) {
    }
    if (!this.bibid) {
      try {
        this.bibid = this.route.snapshot.queryParamMap.get('BibID') ?? '';
      } catch (error) { }
    }

    if (!this.bibid) {
      try {
        this.bibid = this.route.snapshot.queryParamMap.get('JMarcID') ?? '';
      } catch (error) { }
    }

    if (this.bibid.indexOf('j') != -1) {
      this.isArticle = true;
    }

    this.locationID = localStorage.getItem('locationIDMain') ?? ''; //location หลัก

    //เช็คว่าเป็นวารสารหรือไม่
    this.homeService.checkSerial(this.bibid).subscribe((isSerial: boolean) => {
      this.isSerial = isSerial;
    });

    // แสดงรายละเอียดเบื้องต้นของหนังสือโดยมีการแยกไว้เป็น Set เพื่อความสะดวก
    await this.getInfo(this.bibid);

    if (this.bibid.indexOf('j') == -1) {
      // กรณีที่เป็นหนังสือจะมีการแสดงผลที่เพิ่มมามากกว่าบทความวารสาร เช่น บทความจะไม่มี Item

      await this.getBookRelated(this.bibid);
      await this.getBookNewMatType(this.bibid);
    } else {
      // บทความ
      this.isBook = false; // ไม่ใช่หนังสือนะ
      this.mattyeIcon = 'assets/images/Mattype/ArticleGrey.png'; // บทความ=9ไม่ต้องไปวนตรวจสอบ

      await this.GetAllTitleInIssue(this.bibid);

      /**สำหรับตรวจสอบการเปิดใช้งาน RD (Realitem, copy, file) ถ้าปิดจะไม่แสดงปุ่ม RD*/
      await this.CheckOpenRD();

      /*ตรวจสอบ user login*/
      this.currentUser =
        JSON.parse(localStorage.getItem('WALAIcurrentUser') || '[]');

      if (this.currentUser.length != 0) {
        await this.GetBlockNotice(this.currentUser[0].USERID);
        await this.GetNDDUserPrivilege(this.currentUser[0].USERID);
      }
    }

    // สถิติของหนังสือ
    this.getBookStatic(this.bibid);

    this.getBookCoverAll(this.bibid);
    this.genDublinCoreMetadata(this.bibid);
  }



  // แสดงรายละเอียดเบื้องต้นของหนังสือโดยมีการแยกไว้เป็น Set เพื่อความสะดวก
  public async getInfo(bibid: string) {
    this.spinner.show(); // หมุนๆ
    this.loading = true;
    // ส่งค่าไปยัง API
    this.subjectList = [];
    this.isbnList = [];
    this.addedAuthorList = [];
    this.authorList = [];
    (await this.homeService.getBibInfo(bibid)).subscribe(
      (book: any) => {
         console.log(book);
        // รายละเอียดของหนังสือเช่น ผู้แต่งรูป สำหนักพิมพ์
        this.infoList = book.BookInfo;

        if (book.Books.length == 0) {
          this.validParameter = false;
          this.loading = false;
          this.spinner.hide();
          return;
        }
        // ตรวจสอบบางค่าเช่น Subject ที่มีการแยกการแสดงผลเพื่อความสวยงามว่ามีอยู่หรือไม่
        // ซึ่งถ้าไม่มีก็จะไม่ต้องแสดง Label ...ไว้สำหรับตัดข้อมูลแยกแสดงผล
        // เช่นหัวเรื่องอาจจะต้องตัด Lebel ด้านซ้ายออกไปด้วยแล้วให้มาแสดงผลใน บันทัดเดียว
        this.infoList.forEach((element) => {
          // เช็คว่ามี Subject หรือไม่
          if (element.FIELD === 'Subject') {
            this.havesubject = true;
            this.subjectList.push(element);
          }
          if (element.FIELD === 'ISBN') {
            this.haveISBN = true;
            this.isbnList.push(element);
          }
          if (element.FIELD === 'Added Author') {
            const _parts = element.DATA.split('|e');
            element.DATA = _parts[0].trim().replace(/,\s*$/, '');
            element.DATA_SUFFIX = _parts.length > 1 ? _parts[1].trim() : '';
            this.addedAuthor = true;
            this.addedAuthorList.push(element);
          }
          if (element.FIELD === 'Author') {
            const _parts = element.DATA.split('|e');
            element.DATA = _parts[0].trim().replace(/,\s*$/, '');
            element.DATA_SUFFIX = _parts.length > 1 ? _parts[1].trim() : '';
            this.haveAuthor = true;
            this.authorList.push(element);
          }
        });

        // Group duplicate fields for cleaner display
        this.groupInfoByField();

        // หลายค่าจะส่งแยกออกจาก Json หลักเพื่อง่ายต่อการแสดงผล
        this.title = book.Books[0].title;
        this.author = book.Books[0].author;
        this.bookcoverUrl = book.Books[0].bookcover;

        //og:title
        this.meta.updateTag({
          property: 'og:title',
          content: this.title,
        });
        //og:type
        this.meta.updateTag({
          property: 'og:type',
          content: 'website',
        });
        //og:url
        this.meta.updateTag({
          property: 'og:url',
          content: this.url,
        });

        this.meta.updateTag({
          property: 'og:description',
          content: this.title + ' ' + this.author,
        });

        this.meta.updateTag({
          property: 'og:image',
          content: this.bookcoverUrl,
        });



        this.abstract = book.Books[0].abstract; // บทคัดย่อ

        // แสดงผล Url ต่างๆ
        if (book.Books856) {
          // this.book856 = book.Books856;
          this.getGetBook856();
        }

        if (book.Books773t) {
          this.objBook773t = book.Books773t[0];
        }

        // สารบัญ นั้นบรรณารักษ์มักจะคั่นด้วย -- ของแต่ละบทไว้จึงใช้ตัวนี้มาตัดแบ่งการแสดงผล

        const str = book.Books[0].Contents;
        if (str) {
          //  this.contents = str.split('--');
          let t = str.split('<br/>');

          t.forEach((element: any) => {
            if (element != '') {
              let e = element.split('--');

              e.forEach((ee : any) => {
                this.contents.push(ee);
              });
            }
          });
        }

        this.loading = false;
        this.spinner.hide(); // ซ่อนหมุนๆ

      },
      (error) => {
        this.loading = false;
        // ซ่อนหมุนๆ
        this.spinner.hide();
        this.validParameter = false;
      }
    );
  }

  // แสดงรายการหนังสือที่มี Relat กันโดยในเบื้องต้นจะยึด Subject
  public getBookRelated(id: string) {
    this.homeService.getBookRelated(id, 6).subscribe((book: any) => {
      this.bookRelated = book;
    });
  }

  public GetAllTitleInIssue(id: string) {
    this.homeService.getAllTitleInIssue(id).subscribe((book: any) => {
      this.AllTitleInIssue = book;
    });
  }

  // สถิติต่างๆ ของหนังสือ เช่นการวิว การยืมและการเพิ่มใน My List
  public getBookStatic(id: string) {
    this.homeService.getBookStatic(id).subscribe((book: any) => {
      if (book) {
        this.bookStatic = book[0];
        if (this.bookStatic.CHECKOUTCOUNT == null) {
          this.bookStatic.CHECKOUTCOUNT = 0;
        }
      }
    });
  }

  // แสดงข้อมูลประเภททรัพยากร
  public getBookNewMatType(id: any) {
    this.homeService.getBookNewMatType(id).subscribe((mattype: String) => {
      this.mattypeID = mattype.toString();
      this.matTypeName = this.matType.GetMattypeName(this.mattypeID);

      switch (this.mattypeID) {
        case '1': {
          this.mattyeIcon = 'assets/images/Mattype/Book.png';
          break;
        }
        case '2': {
          this.mattyeIcon = 'assets/images/Mattype/SerialGrey.png';
          break;
        }
        case '3': {
          this.mattyeIcon = 'assets/images/Mattype/MusicGrey.png';
          break;
        }
        case '4': {
          this.mattyeIcon = 'assets/images/Mattype/MapGrey.png';
          break;
        }
        case '5': {
          this.mattyeIcon = 'assets/images/Mattype/VisualGrey.png';
          break;
        }
        case '6': {
          this.mattyeIcon = 'assets/images/Mattype/ComputerFileGrey.png';
          break;
        }
        case '7': {
          this.mattyeIcon = 'assets/images/Mattype/MixedGrey.png';
          break;
        }
        case '8': {
          this.mattyeIcon = 'assets/images/Mattype/Book.png';
          break;
        }
        case '9': {
          this.mattyeIcon = 'assets/images/Mattype/ArticleGrey.png';
          break;
        }
        case '10': {
          this.mattyeIcon = 'assets/images/Mattype/eBookGrey.png';

          break;
        }
        case '11': {
          this.mattyeIcon = 'assets/images/Mattype/ThesisGrey.png';
          break;
        }
        default: {
          this.mattyeIcon = 'assets/images/Mattype/Book.png';
          break;
        }
      }
    });
  }

  getBookCoverAll(bibid: string) {
    this.covers = [];
    this.homeService.getBookCoverPath().subscribe((covers: any) => {
      this.bookCoverPath = covers;

      const idNumber = Number(bibid.replace('b', ''));

      this.checkIfImageExists(
        this.bookCoverPath + idNumber + '/' + idNumber + '-fc-a.jpg',
        (exists: any) => { }
      );

      this.checkIfImageExists(
        this.bookCoverPath + idNumber + '/' + idNumber + '-bc-a.jpg',
        (exists: any) => { }
      );

      this.checkIfImageExists(
        this.bookCoverPath + idNumber + '/' + idNumber + '-tp-a.jpg',
        (exists: any) => { }
      );

      //สารบัญ
      this.checkIfImageExists(
        this.bookCoverPath + idNumber + '/' + idNumber + '-tc-a.jpg',
        (exists: any) => {
          for (let i = 1; i <= 20; i++) {
            const pageNum = i < 10 ? '0' + i : i;
            const tcUrl = this.bookCoverPath + idNumber + '/' + idNumber + '-tc' + pageNum + '-a.jpg';
            this.checkIfImageExists(tcUrl, (exists: any) => { });
          }
        }
      );


      
    });
  }

  genDublinCoreMetadata(id: string) {
    this.homeService.getgenDublinCoreMetadata(id).subscribe((meta: any) => {
      if (meta) {
        this.meta.addTags(meta);
      }
    });
  }

  // CHECK IF IMAGE EXISTS

  checkIfImageExists(url: string, callback: { (exists: any): void; (exists: any): void; (exists: any): void; (exists: any): void; (exists: any): void; (arg0: boolean): void; }) {
    const img = new Image();
    img.src = url;

    if (img.complete) {
      this.covers.push(url);
      callback(true);
    } else {
      img.onload = () => {
        this.covers.push(url);
        callback(true);
      };

      img.onerror = () => {
        callback(false);
      };
    }
  }

  save(bibid: string) {
    this.data.saveForExport(bibid);
  }

  getCoverOnError() {
    this.bookcoverUrl = 'assets/images/bookcover/loading.jpg';
    var keyword_ = new Keywords();
    keyword_.CurrentPage = 1;
    keyword_.RowPerPage = 1;
    keyword_.Ntk = 'ID';
    keyword_.Ntt = this.bibid;
    keyword_.Orderby = 'RELEVANCE';
    keyword_.Nto = '';

    this.searchService.keywordsearch(keyword_).subscribe(
      (results: any) => {
        if (results) {
          if (results.Display.length > 0) {
            let useWalaiBookCover = this.configService.useWalaiBookCover;
            if (useWalaiBookCover == '1') {
              this.checkWALAICOVER(results);
            } else {
              this.getCoverByLang(results);
            }
          }
        }
      },
      (error) => {
        this.bookcoverUrl = this.noimage;
        this.meta.updateTag({
          property: 'og:image',
          content: this.bookcoverUrl,
        });
      }
    );
  }

  getCoverByLang(results: any) {
    if (results.Display[0].LANG == 'ภาษาไทย') {
      this.bookcoverUrl = this.fc.getBookTha(results.Display[0].ISBNISSN);

      this.fc.checkIfImageExists(this.bookcoverUrl, (exists: any) => {
        if (!exists) {
          this.bookcoverUrl = this.noimage;
        }
      });
    } else {
      this.bookcoverUrl = this.fc.getBookEng(
        results.Display[0].ISBNISSN,
        this.noimage
      );

      this.fc.checkIfImageExists(this.bookcoverUrl, (exists: any) => {
        if (!exists) {
          this.bookcoverUrl = this.noimage;
        }
      });
    }

    this.meta.updateTag({
      property: 'og:image',
      content: this.bookcoverUrl,
    });
  }
  checkWALAICOVER(results: any) {
    let isbn13 = this.fc.getISBN(results.Display[0].ISBNISSN);
    fetch(
      'https://opac-api.wu.ac.th/synccoverbook/v1/api/GetBookCover/' + isbn13
    )
      .then((response) => response.text())
      .then((result) => {
        this.checkCover(result, results);
      })
      .catch((error) => this.getCoverByLang(results));
  }

  checkCover(url: string, results: any) {
    if (url == '') {
      this.getCoverByLang(results);
    } else {
      this.bookcoverUrl = url;

      this.fc.checkIfImageExists(this.bookcoverUrl, (exists: any) => {
        if (!exists) {
          this.bookcoverUrl = this.noimage;
        }
      });
      this.meta.updateTag({
        property: 'og:image',
        content: this.bookcoverUrl,
      });
    }
  }

  //ประวัติการ Download
  addHistory(url: string) {
    this.data.addDownloadHistory(this.bibid, url);
  }

  replaceBR(text: string) {
    return text.replace('<br/>', '');
  }

  // แสดงรายการ 856
  getGetBook856() {
    this.homeService.getBook856(this.bibid).subscribe((book856: any) => {
      if (book856) {
        this.book856 = book856;
      } else {
        this.book856 = [];
        // this.book856[0].URL
      }
    });
  }



  //User มีสิทธิ์ request dd
  async GetNDDUserPrivilege(USERID: any) {
    this.NDDUserPrivilege = false;
    await this.memberService
      .getNDDUserPrivilege(USERID)
      .subscribe((value: any) => {
        try {
          this.NDDUserPrivilege = value;
        } catch (error) { }
      });
  }

  async CheckOpenRD() {
    try {
      await this.homeService
        .CheckOpenRD()
        .subscribe(async (result: boolean) => {
          this.opacopenRD = result;
        });
    } catch (error) {
      this.opacopenRD = false;
    }
  }

  async GetBlockNotice(USERID: any) {
    await this.memberService.getBlockNotice(USERID).subscribe((value: any) => {
      try {
        if (value.Counts[0].num != '0') {
          this.BLOCKUSER = true;
        }
      } catch (error) { }
    });
  }

  // Group information by FIELD to avoid duplicate labels
  groupInfoByField(): void {
    const grouped = new Map<string, string[]>();

    // Group by FIELD, excluding special fields handled separately
    this.infoList.forEach(info => {
      const field = info.FIELD;

      // Skip fields that are handled separately in the template
      if (['Title', 'Author', 'Subject', 'ISBN', 'Added Author'].includes(field)) {
        return;
      }

      if (!grouped.has(field)) {
        grouped.set(field, []);
      }
      grouped.get(field)?.push(info.DATA);
    });

    // Convert Map to array for template iteration
    this.groupedInfoList = Array.from(grouped.entries()).map(([field, values]) => ({
      field,
      values
    }));
  }

  // Toggle expansion state for a field
  toggleFieldExpansion(field: string): void {
    this.expandedFields.set(field, !this.isFieldExpanded(field));
  }

  // Check if a field is expanded
  isFieldExpanded(field: string): boolean {
    return this.expandedFields.get(field) || false;
  }

  // TrackBy function for better performance
  trackByField(index: number, item: { field: string, values: string[] }): string {
    return item.field;
  }

  // Get visible values based on expansion state
  getVisibleValues(field: string, values: string[]): string[] {
    if (this.isFieldExpanded(field)) {
      return values;
    }
    return values.slice(0, 3);
  }

  // Generate unique key for each value
  getValueKey(field: string, index: number): string {
    return `${field}_${index}`;
  }

  // Toggle individual value expansion
  toggleValueExpansion(field: string, index: number): void {
    const key = this.getValueKey(field, index);
    this.expandedValues.set(key, !this.isValueExpanded(field, index));
  }

  // Check if individual value is expanded
  isValueExpanded(field: string, index: number): boolean {
    const key = this.getValueKey(field, index);
    return this.expandedValues.get(key) || false;
  }
}

interface IBookResult {
  Books: IBook[];
  BookInfo: IBookInfo[];
  Books856: any[];
}

interface IBookInfo {
  FIELD: string;
  DATA: string;
}

interface IBook {
  title: string;
  author: string;
  bookcover: string;
  abstract: string;
  Contents: string;
  JLocation: string;
}